import { gql } from "@apollo/client";

export const GET_OPTIONS = gql`
  query GetOptions($clientId: String!, $voteOnly: Boolean) {
    departments(clientId: $clientId, voteOnly: $voteOnly) {
      name
      id
      active
      votingOnlyBoard
    }
    agendaGroups(clientId: $clientId) {
      name
      id
      bulkVote
      isTopic
    }
    districts(clientId: $clientId) {
      name
      id
      number
    }
    members(clientId: $clientId) {
      name
      id
    }
    inMeetingOptions(clientId: $clientId) {
      id
      roomName
    }
    teams(clientId: $clientId) {
      id
      name
    }
    options(clientId: $clientId) {
      onboarded
    }
  }
`;

export const GET_ROOMS = gql`
  query GetRooms($clientId: String!) {
    inMeetingOptions(clientId: $clientId) {
      id
      roomName
    }
  }
`;

export const GET_DEPARTMENTS = gql`
  query GetOptions($clientId: String!, $voteOnly: Boolean) {
    departments(clientId: $clientId, voteOnly: $voteOnly) {
      name
      id
      active
      memberCount
      votingOnlyBoard
    }
  }
`;

export const GET_FLOWS = gql`
  query GetFlows($clientId: String!) {
    flows(clientId: $clientId) {
      name
      id
      module
      description
      stages {
        _id
      }
    }
    getTriggers(clientId: $clientId) {
      _id
      title
      active
    }
  }
`;

export const GET_FLOWS_TYPE = gql`
  query GetFlowsByType($clientId: String!, $type: String!) {
    flowsByType(clientId: $clientId, type: $type) {
      name
      id
      description
      color {
        bg
        text
      }
    }
  }
`;

export const GET_FLOW = gql`
  query GetFlow($id: ID!) {
    flow(id: $id) {
      name
      id
      module
      description
      color {
        bg
        text
      }
      stages {
        _id
        title
        description
        color {
          bg
          text
        }
        assignments {
          title
          process
          team
          user
          reminder
        }
      }
    }
  }
`;

export const GET_DEPARTMENT = gql`
  query GetDepartment($id: ID!, $department: String, $clientId: String!) {
    department(id: $id) {
      name
      id
      active
      liveComment
      memberMotion
      approvalTemplate
      agendaHeadingTitle
      agendaHeadingBlurb
      agendaFooterBlurb
      agendaFooterNote
      motionText
      motionHeadingTitle
      motionHeadingBlurb
      motionFooterBlurb
      motionFooterNote
      customHeader
      headerDetails
      approver {
        id
        name
      }
      approvalStamp
      voteColor
      micMode
      timerDefault
      liveResultsTimer
      memberResultsTimer
      memberTimer
      tieVote
      hideQueue
      rounds
      autoMicOff
      votingOnlyBoard
    }
    membersByDepartment(clientId: $clientId, department: $department) {
      id
      name
      title
      photoUrl
      memberOf {
        adminRole
        managerRole
        votingRole
        boardId
        boardName
        defaultSeat
        bypassTimer
      }
    }
    agendaGroupsByBoard(clientId: $clientId, department: $department) {
      id
      name
      subheading
      bulkVote
      isClosedSession
      isPublicHearing
      availableLive
      isTopic
      order
      details
    }
  }
`;

export const GET_DEPARTMENT_CONFIG = gql`
  query GetDepartment($id: ID!, $department: String, $clientId: String!) {
    department(id: $id) {
      name
      id
      active
      liveComment
      memberMotion
      approvalTemplate
      agendaHeadingTitle
      agendaHeadingBlurb
      agendaFooterBlurb
      agendaFooterNote
      motionText
      motionHeadingTitle
      motionHeadingBlurb
      motionFooterBlurb
      motionFooterNote
      customHeader
      headerDetails
      approver {
        id
        name
      }
      approvalStamp
      voteColor
      micMode
      timerDefault
      liveResultsTimer
      memberResultsTimer
      memberTimer
      tieVote
      hideQueue
      rounds
      autoMicOff
      votingOnlyBoard
    }
    membersByDepartment(clientId: $clientId, department: $department) {
      id
      name
      title
      photoUrl
      memberOf {
        adminRole
        managerRole
        votingRole
        boardId
        boardName
        defaultSeat
        bypassTimer
      }
    }
    agendaGroupsByBoard(clientId: $clientId, department: $department) {
      id
      name
      subheading
      bulkVote
      isClosedSession
      isPublicHearing
      availableLive
      isTopic
      order
      details
    }
    templateTopicsGroups(department: $department) {
      id
      title
      agendaGroup {
        id
        name
      }
      order
      duration
      topicBlurb
      hasDetails
      allowRegister
      subTopics
      editorType
      details
    }
  }
`;

export const GET_DISTRICTS = gql`
  query GetOptions($clientId: String!) {
    districts(clientId: $clientId) {
      name
      id
    }
  }
`;

export const GET_AGENDA_GROUPS = gql`
  query GetAgendaGroups($clientId: String!) {
    agendaGroups(clientId: $clientId) {
      name
      id
      bulkVote
      isClosedSession
      isPublicHearing
      availableLive
      isTopic
    }
  }
`;

export const GET_GROUPS_ALL = gql`
  query GetAgendaGroups($clientId: String!) {
    agendaGroups(clientId: $clientId) {
      name
      id
      bulkVote
      isTopic
      isClosedSession
      isPublicHearing
      availableLive
      department {
        id
        name
      }
    }
  }
`;

export const GET_GROUPSBYDEP = gql`
  query GetAgendaGroupsByBoard($department: String, $clientId: String!) {
    agendaGroupsByBoard(department: $department, clientId: $clientId) {
      name
      id
      bulkVote
      isClosedSession
      isPublicHearing
      availableLive
      isTopic
    }
  }
`;

export const GET_GROUPSANDPRIORITIES = gql`
  query GetGroupsAndPriorities($department: String, $clientId: String!) {
    agendaGroupsByBoard(department: $department, clientId: $clientId) {
      name
      id
      bulkVote
      isClosedSession
      isPublicHearing
      availableLive
      isTopic
    }
    options(clientId: $clientId) {
      priorities
      enablePriorities
      defaultFont
    }
  }
`;

export const GET_MOTIONS = gql`
  query GetMotions($clientId: String!) {
    motions(clientId: $clientId) {
      id
      name
    }
  }
`;

export const GET_VOTE_TYPES = gql`
  query GetVoteTypes($clientId: String!) {
    voteTypes(clientId: $clientId) {
      id
      name
    }
  }
`;

export const GET_MEETING_OPTIONS = gql`
  query GetMeetingOptions($clientId: String!) {
    inMeetingOptions(clientId: $clientId) {
      id
      requestToSpeak
      hasController
      plugins
      avConnect
      controlIp
      miscProtocolPort
      micControlPort
      customAvControl
      broadcast
      bcastOptions
      customAvButtons {
        title
        command
      }
      bsInput
      entityLogo
      roomName
      address {
        street
        street2
        city
        state
        zipCode
      }
    }
  }
`;

export const GET_LIVE_OPTIONS = gql`
  query GetMeetingOptions($clientId: String!, $id: ID!) {
    inMeetingOption(id: $id) {
      id
      requestToSpeak
      timerDefault
      liveResultsTimer
      memberResultsTimer
      voteColor
      autoVoteClose
      autoNextTopic
      entityLogo
      roomName
    }
    options(clientId: $clientId) {
      logo
      clientName
      defaultFont
    }
  }
`;

export const GET_TEAMS_PAGE = gql`
  query GetTeamsPage($member: ID!, $clientId: String!) {
    teamsPage(member: $member, clientId: $clientId) {
      nonMember {
        id
        name
        memberCount
        assignedItems
      }
      member {
        id
        name
        memberCount
        assignedItems
      }
    }
  }
`;

export const GET_TEAMS = gql`
  query GetTeams($clientId: String!) {
    teams(clientId: $clientId) {
      id
      name
    }
  }
`;

export const GET_CUSTOM_USERS = gql`
  query GetCustomUserLists($clientId: String!, $active: Boolean) {
    customUserLists(clientId: $clientId, active: $active) {
      id
      title
      description
      active
      fieldType
      fieldOptions {
        value
        name
      }
      public
      process
      isUsers
    }
  }
`;

export const GET_PROCESS_FIELDS = gql`
  query GetProcessFields($clientId: String!) {
    processFields(clientId: $clientId) {
      id
      title
      description
      active
      fieldType
      fieldOptions {
        value
        name
      }
      public
      process
    }
  }
`;

export const GET_PLATFORM_OPTIONS = gql`
  query GetPlatformOptions($clientId: String!) {
    options(clientId: $clientId) {
      clientName
      id
      logo
      signatureSeal
      signatureImage
      publicColor
      useSeal
      useSignImage
      onboarded
      priorities
      enablePriorities
      fieldItemNumber
      fieldDistrict
      fieldReferenceFile
      fieldPresentedBy
      fieldAssignedDepartment
      fieldSubItems
      showDuration
      fieldPreparedBy
      memoCalled
      coverHasPresentedBy
      allowSupplemental
      defaultFont
      engageDefault
      cablecastLiveUrl
    }
  }
`;

export const GET_PLATFORM = gql`
  query GetPlatform($clientId: String!) {
    options(clientId: $clientId) {
      clientName
      id
      logo
      defaultFont
      engageDefault
    }
  }
`;
